import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  private userLogOut$: Subject<any> = new Subject();
  constructor() { }
  userLoggedOut() {
    this.userLogOut$.next(true);
  }
  getUserLogOutSubscription() {
    return this.userLogOut$;
  }
}
